var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-row',[_c('p',{staticClass:"pl-3 plan__text",staticStyle:{"text-align":"left","font-weight":"bold","white-space":"nowrap"}},[_c('v-spacer',{staticStyle:{"height":"5px"}}),_c('span',[_vm._v(_vm._s(_vm.totalPrice)+"円")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }